import {
    Directive,
    HostListener,
    Input,
} from '@angular/core';
import { NgControl } from '@angular/forms';

// All blocked special characters — '/' is intentionally excluded (allowed)
const BLOCKED_CHARS_REGEX = /[@#$%^&*!_\-+=,.;:()\[\]{}]/g;

@Directive({
    selector: '[appRestrictSpecialChars]'
})
export class RestrictSpecialCharsDirective {

    constructor(private ngControl: NgControl) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (BLOCKED_CHARS_REGEX.test(event.key)) {
            event.preventDefault();
        }
        // Reset lastIndex since the regex has 'g' flag
        BLOCKED_CHARS_REGEX.lastIndex = 0;
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        event.preventDefault();
        const pastedText = event.clipboardData?.getData('text') ?? '';
        const sanitized = pastedText.replace(BLOCKED_CHARS_REGEX, '');
        BLOCKED_CHARS_REGEX.lastIndex = 0;

        // Patch the form control value directly
        this.ngControl.control?.setValue(sanitized);
    }
}